import { ApiLoaderInterceptor } from './Interceptor/api-loader.interceptor';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './components/home/home.component';
import { HomeFooterComponent } from './components/layouts/home-footer/home-footer.component';
import { HomeHeaderComponent } from './components/layouts/home-header/home-header.component';
import { HomeNavComponent } from './components/layouts/home-nav/home-nav.component';
import { HomePageLayoutComponent } from './components/layouts/home-page-layout/home-page-layout.component';
import { InnerFooterComponent } from './components/layouts/inner-footer/inner-footer.component';
import { InnerHeaderComponent } from './components/layouts/inner-header/inner-header.component';
import { InnerNavComponent } from './components/layouts/inner-nav/inner-nav.component';
import { InnerPageLayoutComponent } from './components/layouts/inner-page-layout/inner-page-layout.component';
import { BankDetailsComponent } from './components/registration/bank-details/bank-details.component';
import { PersonalDetailsComponent } from './components/registration/personal-details/personal-details.component';
import { ErrorInterceptor } from './Interceptor/auth/error.interceptor';
import { JwtInterceptor } from './Interceptor/auth/jwt.interceptor';
import { FarmerLandDetailComponent } from './components/registration/farmer-land-detail/farmer-land-detail.component';
import { OnFarmMiComponent } from './components/registration/on-farm-mi/on-farm-mi.component';
import { MenuService } from './services/app.menu.service';

import { MessageService } from 'primeng/api';
import { ConfirmationService } from 'primeng/api';
import { SharedModule } from 'primeng/api';
import { StyleClassModule } from 'primeng/styleclass';
import { AccordionModule } from 'primeng/accordion';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { AvatarModule } from 'primeng/avatar';
import { AvatarGroupModule } from 'primeng/avatargroup';
import { BadgeModule } from 'primeng/badge';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { CardModule } from 'primeng/card';
import { CarouselModule } from 'primeng/carousel';
import { CascadeSelectModule } from 'primeng/cascadeselect';
import { ChartModule } from 'primeng/chart';
import { CheckboxModule } from 'primeng/checkbox';
import { ChipModule } from 'primeng/chip';
import { ChipsModule } from 'primeng/chips';
import { CodeHighlighterModule } from 'primeng/codehighlighter';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { ColorPickerModule } from 'primeng/colorpicker';
import { ContextMenuModule } from 'primeng/contextmenu';
import { DataViewModule } from 'primeng/dataview';
import { DialogModule } from 'primeng/dialog';
import { DividerModule } from 'primeng/divider';
import { DropdownModule } from 'primeng/dropdown';
import { FieldsetModule } from 'primeng/fieldset';
import { FileUploadModule } from 'primeng/fileupload';
import { GalleriaModule } from 'primeng/galleria';
import { ImageModule } from 'primeng/image';
import { InplaceModule } from 'primeng/inplace';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputMaskModule } from 'primeng/inputmask';
import { InputSwitchModule } from 'primeng/inputswitch';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { KnobModule } from 'primeng/knob';
import { LightboxModule } from 'primeng/lightbox';
import { ListboxModule } from 'primeng/listbox';
import { MegaMenuModule } from 'primeng/megamenu';
import { MenuModule } from 'primeng/menu';
import { MenubarModule } from 'primeng/menubar';
import { MessagesModule } from 'primeng/messages';
import { MessageModule } from 'primeng/message';
import { MultiSelectModule } from 'primeng/multiselect';
import { OrderListModule } from 'primeng/orderlist';
import { OrganizationChartModule } from 'primeng/organizationchart';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { PaginatorModule } from 'primeng/paginator';
import { PanelModule } from 'primeng/panel';
import { PanelMenuModule } from 'primeng/panelmenu';
import { PasswordModule } from 'primeng/password';
import { PickListModule } from 'primeng/picklist';
import { RadioButtonModule } from 'primeng/radiobutton';
import { RatingModule } from 'primeng/rating';
import { RippleModule } from 'primeng/ripple';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { ScrollTopModule } from 'primeng/scrolltop';
import { SelectButtonModule } from 'primeng/selectbutton';
import { SidebarModule } from 'primeng/sidebar';
import { SkeletonModule } from 'primeng/skeleton';
import { SlideMenuModule } from 'primeng/slidemenu';
import { SliderModule } from 'primeng/slider';
import { SplitButtonModule } from 'primeng/splitbutton';
import { SplitterModule } from 'primeng/splitter';
import { StepsModule } from 'primeng/steps';
import { TabMenuModule } from 'primeng/tabmenu';
import { TableModule } from 'primeng/table';
import { TabViewModule } from 'primeng/tabview';
import { TagModule } from 'primeng/tag';
import { TerminalModule } from 'primeng/terminal';
import { TieredMenuModule } from 'primeng/tieredmenu';
import { TimelineModule } from 'primeng/timeline';
import { ToastModule } from 'primeng/toast';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { ToolbarModule } from 'primeng/toolbar';
import { TooltipModule } from 'primeng/tooltip';
import { TreeModule } from 'primeng/tree';
import { TreeSelectModule } from 'primeng/treeselect';
import { TreeTableModule } from 'primeng/treetable';
import { VirtualScrollerModule } from 'primeng/virtualscroller';
import { ConfigService } from './services/app.config.service';
import { AppMenuComponent } from './components/layouts/inner-nav/app.menu.component';
import { AppMenuitemComponent } from './components/layouts/inner-nav/app.menuitem.component';
import { AppTopBarComponent } from './components/layouts/inner-page-layout/app.topbar.component';
import { FarmerLandDetailService } from './services/farmer-land-detail.service';
import { TokenService } from './services/common/token.service';
import { OnFarmMiService } from './services/on-farm-mi.service';
import { LoginComponent } from './components/login/login.component';
import { ProgressBarModule } from 'primeng/progressbar';
import { KeyFilterModule } from 'primeng/keyfilter';
import { PhoneLoginComponent } from './components/phone-login/phone-login.component';
import { FarmersApplicationComponent } from './components/application/farmers-application/farmers-application.component';
import { ConsentFormComponent } from './components/application/consent-form/consent-form.component';

import { DashboardComponent } from './components/dashboard/dashboard.component';
import { DepartmentConsentFormComponent } from './components/department/department-consent-form/department-consent-form.component';
import { VendorComponent } from './components/vendor/vendor.component';
import { VendorConsentFormComponent } from './components/vendor/vendor-consent-form/vendor-consent-form.component';
import { FarmerDashboardComponent } from './components/farmer-dashboard/farmer-dashboard.component';
import { PondProgressIntimationComponent } from './components/pond-progress-intimation/pond-progress-intimation.component';
import { VendorBOQComponent } from './components/vendor/vendor-boq/vendor-boq.component';
import { MiChallanComponent } from './components/challan/mi-challan/mi-challan.component';
import { SolarChallanComponent } from './components/challan/solar-challan/solar-challan.component';
import { FarmerShareComponent } from './components/challan/mi-challan/farmer-share/farmer-share.component';
import { FullPaymentComponent } from './components/challan/mi-challan/full-payment/full-payment.component';
import { VendorMiEstimationConsentFormComponent } from './components/department/vendor-mi-estimation-consent-form/vendor-mi-estimation-consent-form.component';
import { PondEstimateComponent } from './components/pond-estimate/pond-estimate.component';
import { AppLoaderComponent } from './services/app-loader/app-loader.component';
import { SanctionLetterComponent } from './components/challan/mi-challan/sanction-letter/sanction-letter.component';
import { FarmerApplicationVerificationComponent } from './components/department/farmer-application-verification/farmer-application-verification.component';
import { MiVendorApplicationVerificationComponent } from './components/department/mi-vendor-application-verification/mi-vendor-application-verification.component';
import { WorkFlowAllStatusComponent } from './components/department/farmer-application-verification/work-flow-all-status/work-flow-all-status.component';
import { LandingComponent } from './components/landing/landing.component';
import { ActivitiesComponent } from './components/activities/activities.component';
import { OrganizationalSetupComponent } from './components/organizational-setup/organizational-setup.component';
import { StatisticsComponent } from './components/statistics/statistics.component';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { FullPaymentchallanDetailsComponent } from './components/vendor/full-paymentchallan-details/full-paymentchallan-details.component';
import { ReportSummaryComponent } from './components/department/report-summary/report-summary.component';
import { JeApplicationComponent } from './components/je/je-application/je-application.component';
import { BasicComponent } from './components/je/basic/basic.component';
import { FinanceComponent } from './components/je/finance/finance.component';
import { AttachmentComponent } from './components/je/attachment/attachment.component';
import { JeComponent } from './components/je/je.component';
import { MiPhysicalVerificationsComponent } from './components/je/mi-physical-verifications/mi-physical-verifications.component';
import { VendorApplicationComponent } from './components/vendor/vendor-application/vendor-application.component';
import { PrintFarmersChallanComponent } from './components/department/print-farmers-challan/print-farmers-challan.component';
import { CameraComponent } from './components/camera/camera.component';
import { WebcamModule } from 'ngx-webcam';
import { HelpdeskComponent } from './components/helpdesk/helpdesk.component';
import { UpdateMiComponentCmlValidityComponent } from './components/department/update-mi-component-cml-validity/update-mi-component-cml-validity.component';
import { ChangeRequestComponent } from './components/farmer/change-request/change-request.component';
import { SdoComponent } from './components/sdo/sdo.component';
import { ViewFormComponent } from './components/sdo/view-form/view-form.component';
import { FarmerAppChangeRequestComponent } from './components/department/farmer-app-change-request/farmer-app-change-request.component';
import { NewInitiativesComponent } from './components/new-initiatives/new-initiatives.component';
import { RtiComponent } from './components/rti/rti.component';
import { MiSurveyComponent } from './components/department/subsidy-lot/mi-survey/mi-survey.component';
import { MiSurveySubsidyDisbursementComponent } from './components/cao/mi-survey-subsidy-disbursement/mi-survey-subsidy-disbursement.component';
import { CaoComponent } from './components/cao/cao.component';
import { ApproveFarmersChallanComponent } from './components/department/approve-farmers-challan/approve-farmers-challan.component';
import { ViewFarmerApplicationComponent } from './components/je/view-farmer-application/view-farmer-application.component';
import { FarmerShareToVendorComponent } from './components/department/subsidy-lot/farmer-share-to-vendor/farmer-share-to-vendor.component';
import { SubsidyToVendorComponent } from './components/department/subsidy-lot/subsidy-to-vendor/subsidy-to-vendor.component';
import { SubsidyToFarmerComponent } from './components/department/subsidy-lot/subsidy-to-farmer/subsidy-to-farmer.component';
import { RefundToFarmerComponent } from './components/department/subsidy-lot/refund-to-farmer/refund-to-farmer.component';
import { FarmerShareToVendorPfmsReportComponent } from './components/cao/farmer-share-to-vendor-pfms-report/farmer-share-to-vendor-pfms-report.component';
import { SubsidyToVendorPfmsReportComponent } from './components/cao/subsidy-to-vendor-pfms-report/subsidy-to-vendor-pfms-report.component';
import { SubsidyToFarmerPfmsReportComponent } from './components/cao/subsidy-to-farmer-pfms-report/subsidy-to-farmer-pfms-report.component';
import { ReturnToFarmerPfmsReportComponent } from './components/cao/return-to-farmer-pfms-report/return-to-farmer-pfms-report.component';
import { XenComponent } from './components/xen/xen.component';
import { XenFormComponent } from './components/xen/xen-form/xen-form.component';
import { TankStage1Component } from './components/tank-stage1/tank-stage1.component';
import { TankStage2Component } from './components/tank-stage2/tank-stage2.component';
import { TankStage3Component } from './components/tank-stage3/tank-stage3.component';
import { EvaluationStudyComponent } from './components/evaluation-study/evaluation-study.component';
import { AchievementsComponent } from './components/achievements/achievements.component';
import { AnnualPlanComponent } from './components/annual-plan/annual-plan.component';
import { ProjectComponent } from './components/project/project.component';
import { MicroIrrigationComponent } from './components/micro-irrigation/micro-irrigation.component';
import { ImportPfmsDataComponent } from './components/cao/import-pfms-data/import-pfms-data.component';
import { Tankstagesurvey2Component } from './components/department/subsidy-lot/tankstagesurvey2/tankstagesurvey2.component';
import { Tankstagesurvey3Component } from './components/department/subsidy-lot/tankstagesurvey3/tankstagesurvey3.component';
import { Tankstagesurvey1Component } from './components/department/subsidy-lot/tankstagesurvey1/tankstagesurvey1.component';
import { TankStage1PfmsReportComponent } from './components/cao/tank-stage1-pfms-report/tank-stage1-pfms-report.component';
import { TankStage2PfmsReportComponent } from './components/cao/tank-stage2-pfms-report/tank-stage2-pfms-report.component';
import { TankStage3PfmsReportComponent } from './components/cao/tank-stage3-pfms-report/tank-stage3-pfms-report.component';
import { TankStagePfmsImportComponent } from './components/cao/tank-stage-pfms-import/tank-stage-pfms-import.component';

import { GoogleMapComponent } from './components/google-map/google-map.component';
import { ViewCoOrdinatesComponent } from './components/department/view-co-ordinates/view-co-ordinates.component';
import {GMapModule} from 'primeng/gmap';
import { AppVerificationReportComponent } from './components/department/reports/app-verification-report/app-verification-report.component';
import { DepartmentDashboardComponent } from './components/department/department-dashboard/department-dashboard.component';
import { MonthWiseReportComponent } from './components/department/reports/app-verification-report/month-wise-report/month-wise-report.component';
import { DistrictWiseReportComponent } from './components/department/reports/app-verification-report/district-wise-report/district-wise-report.component';
import { UserWiseReportComponent } from './components/department/reports/app-verification-report/user-wise-report/user-wise-report.component';
import { VendorWiseReportComponent } from './components/department/reports/app-verification-report/vendor-wise-report/vendor-wise-report.component';
import { EstimationReportComponent } from './components/department/reports/estimation-report/estimation-report.component';
import { EstimationMonthWiseReportComponent } from './components/department/reports/estimation-report/estimation-month-wise-report/estimation-month-wise-report.component';
import { EstimationDistrictWiseReportComponent } from './components/department/reports/estimation-report/estimation-district-wise-report/estimation-district-wise-report.component';
import { EstimationUserWiseReportComponent } from './components/department/reports/estimation-report/estimation-user-wise-report/estimation-user-wise-report.component';
import { EstimationVendorWiseReportComponent } from './components/department/reports/estimation-report/estimation-vendor-wise-report/estimation-vendor-wise-report.component';
import { BOQReportComponent } from './components/department/reports/boq-report/boq-report.component';
import { BoqMonthWiseReportComponent } from './components/department/reports/boq-report/boq-month-wise-report/boq-month-wise-report.component';
import { BoqDistrictWiseReportComponent } from './components/department/reports/boq-report/boq-district-wise-report/boq-district-wise-report.component';
import { BoqVendorWiseReportComponent } from './components/department/reports/boq-report/boq-vendor-wise-report/boq-vendor-wise-report.component';
import { BoqMiTypeReportComponent } from './components/department/reports/boq-report/boq-mi-type-report/boq-mi-type-report.component';
import { EstimationVerificationReportComponent } from './components/department/reports/estimation-verification-report/estimation-verification-report.component';
import { EstVerificationMonthWiseReportComponent } from './components/department/reports/estimation-verification-report/est-verification-month-wise-report/est-verification-month-wise-report.component';
import { EstVerificationDistrictWiseReportComponent } from './components/department/reports/estimation-verification-report/est-verification-district-wise-report/est-verification-district-wise-report.component';
import { EstVerificationVendorWiseReportComponent } from './components/department/reports/estimation-verification-report/est-verification-vendor-wise-report/est-verification-vendor-wise-report.component';
import { EstVerificationUserWiseReportComponent } from './components/department/reports/estimation-verification-report/est-verification-user-wise-report/est-verification-user-wise-report.component';
import { ChallanReportComponent } from './components/department/reports/challan-report/challan-report.component';
import { ChallanDistrictWiseReportComponent } from './components/department/reports/challan-report/challan-district-wise-report/challan-district-wise-report.component';
import { ChallanVendorWiseReportComponent } from './components/department/reports/challan-report/challan-vendor-wise-report/challan-vendor-wise-report.component';
import { PhysicalVerificationReportComponent } from './components/department/reports/physical-verification-report/physical-verification-report.component';
import { PhysicalVerificationMonthWiseReportComponent } from './components/department/reports/physical-verification-report/physical-verification-month-wise-report/physical-verification-month-wise-report.component';
import { PhysicalVerificationDistrictWiseReportComponent } from './components/department/reports/physical-verification-report/physical-verification-district-wise-report/physical-verification-district-wise-report.component';
import { PhysicalVerificationVendorWiseReportComponent } from './components/department/reports/physical-verification-report/physical-verification-vendor-wise-report/physical-verification-vendor-wise-report.component';
import { PhysicalVerificationUserWiseReportComponent } from './components/department/reports/physical-verification-report/physical-verification-user-wise-report/physical-verification-user-wise-report.component';
import { FsvReportComponent } from './components/department/reports/fsv-report/fsv-report.component';
import { FsvMonthWiseReportComponent } from './components/department/reports/fsv-report/fsv-month-wise-report/fsv-month-wise-report.component';
import { FsvDistrictWiseReportComponent } from './components/department/reports/fsv-report/fsv-district-wise-report/fsv-district-wise-report.component';
import { FsvVendorWiseReportComponent } from './components/department/reports/fsv-report/fsv-vendor-wise-report/fsv-vendor-wise-report.component';
import { VendorFarmerApplicationComponent } from './components/vendor/vendor-farmer-application/vendor-farmer-application.component';
import { AllSubsidyLotComponent } from './components/department/subsidy-lot/all-subsidy-lot/all-subsidy-lot.component';
import { StvReportComponent } from './components/department/reports/stv-report/stv-report.component';
import { StfReportComponent } from './components/department/reports/stf-report/stf-report.component';
import { StvMonthWiseComponent } from './components/department/reports/stv-report/stv-month-wise/stv-month-wise.component';
import { StvVendorWiseReportComponent } from './components/department/reports/stv-report/stv-vendor-wise-report/stv-vendor-wise-report.component';
import { StfDistrictWiseReportComponent } from './components/department/reports/stf-report/stf-district-wise-report/stf-district-wise-report.component';
import { StvDistrictWiseReportComponent } from './components/department/reports/stv-report/stv-district-wise-report/stv-district-wise-report.component';
import { StfMonthWiseReportComponent } from './components/department/reports/stf-report/stf-month-wise-report/stf-month-wise-report.component';
import { StfVendorWiseReportComponent } from './components/department/reports/stf-report/stf-vendor-wise-report/stf-vendor-wise-report.component';
import { RtfReportComponent } from './components/department/reports/rtf-report/rtf-report.component';
import { RtfDistrictWiseReportComponent } from './components/department/reports/rtf-report/rtf-district-wise-report/rtf-district-wise-report.component';
import { RtfMonthWiseReportComponent } from './components/department/reports/rtf-report/rtf-month-wise-report/rtf-month-wise-report.component';
import { RtfVendorWiseReportComponent } from './components/department/reports/rtf-report/rtf-vendor-wise-report/rtf-vendor-wise-report.component';
import { VendorMiAreaReportComponent } from './components/department/reports/vendor-mi-area-report/vendor-mi-area-report.component';
import { MiVerificationSubsidyReportComponent } from './components/department/reports/mi-verification-subsidy-report/mi-verification-subsidy-report.component';
import { TankAbstractReportComponent } from './components/department/reports/tank-abstract-report/tank-abstract-report.component';
import { Stage1ReportComponent } from './components/department/reports/stage1-report/stage1-report.component';
import { Stage2ReportComponent } from './components/department/reports/stage2-report/stage2-report.component';
import { Stage3ReportComponent } from './components/department/reports/stage3-report/stage3-report.component';
import { Stage1SubsidyReportComponent } from './components/department/reports/stage1-subsidy-report/stage1-subsidy-report.component';
import { Stage2SubsidyReportComponent } from './components/department/reports/stage2-subsidy-report/stage2-subsidy-report.component';
import { Stage3SubsidyReportComponent } from './components/department/reports/stage3-subsidy-report/stage3-subsidy-report.component';
import { CanalAndTubeWellBasedReportComponent } from './components/department/reports/canal-and-tube-well-based-report/canal-and-tube-well-based-report.component';
import { ChallanMonthWiseReportComponent } from './components/department/reports/challan-report/challan-month-wise-report/challan-month-wise-report.component';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { FarmerApplicationVerificationPendingComponent } from './components/department/farmer-application-verification/farmer-application-verification-pending/farmer-application-verification-pending.component';
import { FarmerApplicationVerificationCompletedComponent } from './components/department/farmer-application-verification/farmer-application-verification-completed/farmer-application-verification-completed.component';
import { FarmerApplicationVerificationCurrentComponent } from './components/department/farmer-application-verification/farmer-application-verification-current/farmer-application-verification-current.component';
import { YearWiseProgressComponent } from './components/department/year-wise-progress/year-wise-progress.component';
import { MiAreaCoveredComponent } from './components/department/mi-area-covered/mi-area-covered.component';
import { RealtimeDataPdmcSchemeComponent } from './components/department/realtime-data-pdmc-scheme/realtime-data-pdmc-scheme.component';
import { MiVendorApplicationVerificationPendingComponent } from './components/department/mi-vendor-application-verification/mi-vendor-application-verification-pending/mi-vendor-application-verification-pending.component';
import { MiVendorApplicationVerificationCurrentComponent } from './components/department/mi-vendor-application-verification/mi-vendor-application-verification-current/mi-vendor-application-verification-current.component';
import { MiVendorApplicationVerificationApprovedComponent } from './components/department/mi-vendor-application-verification/mi-vendor-application-verification-approved/mi-vendor-application-verification-approved.component';
// import { GeolocationComponent } from './components/geolocation/geolocation.component';
import { PreEstimateSurveyComponent } from './components/vendor/pre-estimate-survey/pre-estimate-survey.component';
import { MiSourceLocationComponent } from './components/je/mi-source-location/mi-source-location.component';
import { ChallanReconciliationDayReportComponent } from './components/department/reports/challan-reconciliation-day-report/challan-reconciliation-day-report.component';
import { MiPhysicalLocationComponent } from './components/micada_1.0/mi-physical-location/mi-physical-location.component';
import { DrillDownApprovedIncompleteReportComponent } from './components/department/reports/drill-down-approved-incomplete-report/drill-down-approved-incomplete-report.component';
import { SeventyFiveHundredDemoComponent } from './components/department/reports/seventy-five-hundred-demo/seventy-five-hundred-demo.component';
import { AtalUserComponent } from './components/department/reports/atal-user/atal-user.component';
import { DrillDownTotalReportComponent } from './components/department/reports/drill-down-total-report/drill-down-total-report.component';
import { DrillDownPendingReportComponent } from './components/department/reports/drill-down-pending-report/drill-down-pending-report.component';
import { DrillDownRejectedReportComponent } from './components/department/reports/drill-down-rejected-report/drill-down-rejected-report.component';
import { ChallanDrillDownReportComponent } from './components/department/reports/challan-drill-down-report/challan-drill-down-report.component';
import { DrillDownAbstractReportComponent } from './components/department/reports/drill-down-abstract-report/drill-down-abstract-report.component';
import { MiInventoryDetailsComponent } from './components/vendor/mi-inventory-details/mi-inventory-details.component';
import { DrillDownTankStageReportComponent } from './components/department/reports/drill-down-tank-stage-report/drill-down-tank-stage-report.component';
import { DaReportComponent } from './components/department/reports/da-report/da-report.component';
import { MiDaReportComponent } from './components/department/reports/da-report/mi-da-report/mi-da-report.component';
import { PondDaReportComponent } from './components/department/reports/da-report/pond-da-report/pond-da-report.component';
import { VendorPreEstimationReportComponent } from './components/department/reports/vendor-pre-estimation-report/vendor-pre-estimation-report.component';
import { PreEstimateMonthWiseReportComponent } from './components/department/reports/vendor-pre-estimation-report/pre-estimate-month-wise-report/pre-estimate-month-wise-report.component';
import { PreEstimateDistrictWiseReportComponent } from './components/department/reports/vendor-pre-estimation-report/pre-estimate-district-wise-report/pre-estimate-district-wise-report.component';
import { PreEstimateUserWiseReportComponent } from './components/department/reports/vendor-pre-estimation-report/pre-estimate-user-wise-report/pre-estimate-user-wise-report.component';
import { PreEstimateVendorWiseReportComponent } from './components/department/reports/vendor-pre-estimation-report/pre-estimate-vendor-wise-report/pre-estimate-vendor-wise-report.component';
import { UploadGstComponent } from './components/vendor/upload-gst/upload-gst.component';
import { ImportBankDataComponent } from './components/cao/import-bank-data/import-bank-data.component';
import { OfficeOrdersComponent } from './components/office-orders/office-orders.component';
import { ConsolidatedReportComponent } from './components/department/reports/consolidated-report/consolidated-report.component';
import { PondConsolidateReportComponent } from './components/department/reports/pond-consolidate-report/pond-consolidate-report.component';
import { VendorAppCurrentComponent } from './components/vendor/vendor-application/vendor-app-current/vendor-app-current.component';
import { VendorAppApprovedComponent } from './components/vendor/vendor-application/vendor-app-approved/vendor-app-approved.component';
import { VendorAppPendingComponent } from './components/vendor/vendor-application/vendor-app-pending/vendor-app-pending.component';
import { RequestSolarComponent } from './components/dev/request-solar/request-solar.component';
import { SolarProcedureComponent } from './components/dev/solar-procedure/solar-procedure.component';
import { AddToSolarFlowComponent } from './components/dev/add-to-solar-flow/add-to-solar-flow.component';
import { ModifySolarComponent } from './components/dev/modify-solar/modify-solar.component';
import { GetSolarComponent } from './components/dev/get-solar/get-solar.component';
import { SolarListComponent } from './components/dev/solar-list/solar-list.component';
import { MiPhysicalVerficationCompletedComponent } from './components/je/mi-physical-verifications/mi-physical-verfication-completed/mi-physical-verfication-completed.component';
import { MiPhysicalVerificationCurrentComponent } from './components/je/mi-physical-verifications/mi-physical-verification-current/mi-physical-verification-current.component';
import { MiPhysicalVerificationPendingComponent } from './components/je/mi-physical-verifications/mi-physical-verification-pending/mi-physical-verification-pending.component';
import { ApplicationTypeReportComponent } from './components/department/application-type-report/application-type-report.component';
import { SanctionLetterComponentComponent } from './components/challan/sanction-letter-component/sanction-letter-component.component';
import { ImageAttachmentsComponent } from './components/je/image-attachments/image-attachments.component';
// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
    HomePageLayoutComponent,
    HomeFooterComponent,
    HomeHeaderComponent,
    InnerPageLayoutComponent,
    InnerHeaderComponent,
    InnerNavComponent,
    HomeNavComponent,
    HomeComponent,
    PersonalDetailsComponent,
    InnerFooterComponent,
    BankDetailsComponent,
    FarmerLandDetailComponent,
    OnFarmMiComponent,
    AppMenuComponent,
    AppMenuitemComponent,
    AppTopBarComponent,
    LoginComponent,
    PhoneLoginComponent,
    FarmersApplicationComponent,
    DashboardComponent,
    ConsentFormComponent,
    DepartmentConsentFormComponent,
    FarmersApplicationComponent,
    VendorComponent,
    VendorConsentFormComponent,
    FarmerDashboardComponent,
    PondProgressIntimationComponent,
    VendorBOQComponent,
    MiChallanComponent,
    SolarChallanComponent,
    FarmerShareComponent,
    FullPaymentComponent,
    VendorMiEstimationConsentFormComponent,
    PondEstimateComponent,
    AppLoaderComponent,
    SanctionLetterComponent,
    FarmerApplicationVerificationComponent,
    MiVendorApplicationVerificationComponent,
    WorkFlowAllStatusComponent,
    LandingComponent,
    ActivitiesComponent,
    OrganizationalSetupComponent,
    StatisticsComponent,
    ForgotPasswordComponent,
    FullPaymentchallanDetailsComponent,
    ReportSummaryComponent,
    JeApplicationComponent,
    BasicComponent,
    FinanceComponent,
    AttachmentComponent,
    JeComponent,
    MiPhysicalVerificationsComponent,
    VendorApplicationComponent,
    PrintFarmersChallanComponent,
    CameraComponent,
    HelpdeskComponent,
    UpdateMiComponentCmlValidityComponent,
    ChangeRequestComponent,
    SdoComponent,
    ViewFormComponent,
    FarmerAppChangeRequestComponent,
    NewInitiativesComponent,
    RtiComponent,
    MiSurveyComponent,
    MiSurveySubsidyDisbursementComponent,
    CaoComponent,
    ApproveFarmersChallanComponent,
    ViewFarmerApplicationComponent,
    FarmerShareToVendorComponent,
    SubsidyToVendorComponent,
    SubsidyToFarmerComponent,
    RefundToFarmerComponent,
    FarmerShareToVendorPfmsReportComponent,
    SubsidyToVendorPfmsReportComponent,
    SubsidyToFarmerPfmsReportComponent,
    ReturnToFarmerPfmsReportComponent,
    XenComponent,
    XenFormComponent,
    TankStage1Component,
    TankStage2Component,
    TankStage3Component,
    EvaluationStudyComponent,
    AchievementsComponent,
    AnnualPlanComponent,
    ProjectComponent,
    MicroIrrigationComponent,
    ImportPfmsDataComponent,
    Tankstagesurvey1Component,
    Tankstagesurvey2Component,
    Tankstagesurvey3Component,
    TankStage1PfmsReportComponent,
    TankStage2PfmsReportComponent,
    TankStage3PfmsReportComponent,
    TankStagePfmsImportComponent,
    GoogleMapComponent,
    ViewCoOrdinatesComponent,
    AppVerificationReportComponent,
    DepartmentDashboardComponent,
    MonthWiseReportComponent,
    DistrictWiseReportComponent,
    UserWiseReportComponent,
    VendorWiseReportComponent,
    EstimationReportComponent,
    EstimationMonthWiseReportComponent,
    EstimationDistrictWiseReportComponent,
    EstimationUserWiseReportComponent,
    EstimationVendorWiseReportComponent,
    BOQReportComponent,
    BoqMonthWiseReportComponent,
    BoqDistrictWiseReportComponent,
    BoqVendorWiseReportComponent,
    BoqMiTypeReportComponent,
    EstimationVerificationReportComponent,
    EstVerificationMonthWiseReportComponent,
    EstVerificationDistrictWiseReportComponent,
    EstVerificationVendorWiseReportComponent,
    EstVerificationUserWiseReportComponent,
    ChallanReportComponent,
    ChallanDistrictWiseReportComponent,
    ChallanVendorWiseReportComponent,
    PhysicalVerificationReportComponent,
    PhysicalVerificationMonthWiseReportComponent,
    PhysicalVerificationDistrictWiseReportComponent,
    PhysicalVerificationVendorWiseReportComponent,
    PhysicalVerificationUserWiseReportComponent,
    FsvReportComponent,
    FsvMonthWiseReportComponent,
    FsvDistrictWiseReportComponent,
    FsvVendorWiseReportComponent,
    VendorFarmerApplicationComponent,
    AllSubsidyLotComponent,
    StvReportComponent,
    StfReportComponent,
    StvMonthWiseComponent,
    StvVendorWiseReportComponent,
    StfDistrictWiseReportComponent,
    StfDistrictWiseReportComponent,
    StvDistrictWiseReportComponent,
    StfMonthWiseReportComponent,
    StfVendorWiseReportComponent,
    RtfReportComponent,
    RtfDistrictWiseReportComponent,
    RtfMonthWiseReportComponent,
    RtfVendorWiseReportComponent,
    VendorMiAreaReportComponent,
    MiVerificationSubsidyReportComponent,
    TankAbstractReportComponent,
    Stage1ReportComponent,
    Stage2ReportComponent,
    Stage3ReportComponent,
    Stage1SubsidyReportComponent,
    Stage2SubsidyReportComponent,
    Stage3SubsidyReportComponent,
    CanalAndTubeWellBasedReportComponent,
    ChallanMonthWiseReportComponent,
    FarmerApplicationVerificationPendingComponent,
    FarmerApplicationVerificationCompletedComponent,
    FarmerApplicationVerificationCurrentComponent,
    YearWiseProgressComponent,
    MiAreaCoveredComponent,
    RealtimeDataPdmcSchemeComponent,
    MiVendorApplicationVerificationPendingComponent,
    MiVendorApplicationVerificationCurrentComponent,
    MiVendorApplicationVerificationApprovedComponent,
    // GeolocationComponent,
    PreEstimateSurveyComponent,
    MiSourceLocationComponent,
    ChallanReconciliationDayReportComponent,
    MiPhysicalLocationComponent,
    DrillDownApprovedIncompleteReportComponent,
    SeventyFiveHundredDemoComponent,
    AtalUserComponent,
    DrillDownTotalReportComponent,
    DrillDownPendingReportComponent,
    DrillDownRejectedReportComponent,
    ChallanDrillDownReportComponent,
    DrillDownAbstractReportComponent,
    MiInventoryDetailsComponent,
    DrillDownTankStageReportComponent,
    DaReportComponent,
    MiDaReportComponent,
    PondDaReportComponent,
    VendorPreEstimationReportComponent,
    PreEstimateMonthWiseReportComponent,
    PreEstimateDistrictWiseReportComponent,
    PreEstimateUserWiseReportComponent,
    PreEstimateVendorWiseReportComponent,
    UploadGstComponent,
    ImportBankDataComponent,
    OfficeOrdersComponent,
    ConsolidatedReportComponent,
    PondConsolidateReportComponent,
    VendorAppCurrentComponent,
    VendorAppApprovedComponent,
    VendorAppPendingComponent,
    RequestSolarComponent,
    SolarProcedureComponent,
    AddToSolarFlowComponent,
    ModifySolarComponent,
    GetSolarComponent,
    MiPhysicalVerficationCompletedComponent,
    MiPhysicalVerificationCurrentComponent,
    MiPhysicalVerificationPendingComponent,
    SolarListComponent, 
    ApplicationTypeReportComponent, 
    SanctionLetterComponentComponent, 
    ImageAttachmentsComponent,
  
  ],
  imports: [
    HttpClientModule,
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    // primeng modules
    CardModule,
    ButtonModule,
    InputTextModule,
    RadioButtonModule,
    MenuModule,
    ToolbarModule,
    ConfirmDialogModule,
    KeyFilterModule,
    InputNumberModule,
    DropdownModule,
    DialogModule,
    TableModule,
    RatingModule,
    BrowserModule,
    StepsModule,
    TabMenuModule,
    TabViewModule,
    TagModule,
    TerminalModule,
    TieredMenuModule,
    TimelineModule,
    ToastModule,
    ToggleButtonModule,
    TooltipModule,
    TreeModule,
    TreeSelectModule,
    TreeTableModule,
    VirtualScrollerModule,
    FormsModule,
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule,
    AccordionModule,
    AutoCompleteModule,
    AvatarModule,
    AvatarGroupModule,
    BadgeModule,
    BreadcrumbModule,
    ButtonModule,
    CalendarModule,
    CardModule,
    CarouselModule,
    CascadeSelectModule,
    ChartModule,
    CheckboxModule,
    ChipsModule,
    ChipModule,
    CodeHighlighterModule,
    ConfirmDialogModule,
    ConfirmPopupModule,
    ColorPickerModule,
    ContextMenuModule,
    DataViewModule,
    DialogModule,
    DividerModule,
    DropdownModule,
    FieldsetModule,
    FileUploadModule,
    GalleriaModule,
    ImageModule,
    InplaceModule,
    InputNumberModule,
    InputMaskModule,
    InputSwitchModule,
    InputTextModule,
    InputTextareaModule,
    KnobModule,
    LightboxModule,
    ListboxModule,
    MegaMenuModule,
    MenuModule,
    MenubarModule,
    MessageModule,
    MessagesModule,
    MultiSelectModule,
    OrderListModule,
    OrganizationChartModule,
    OverlayPanelModule,
    PaginatorModule,
    PanelModule,
    PanelMenuModule,
    PasswordModule,
    PickListModule,
    ProgressBarModule,
    RadioButtonModule,
    RatingModule,
    RippleModule,
    ScrollPanelModule,
    ScrollTopModule,
    SelectButtonModule,
    SidebarModule,
    SkeletonModule,
    SlideMenuModule,
    SliderModule,
    SplitButtonModule,
    SplitterModule,
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule,
    AccordionModule,
    AutoCompleteModule,
    AvatarModule,
    AvatarGroupModule,
    BadgeModule,
    BreadcrumbModule,
    ButtonModule,
    CalendarModule,
    CardModule,
    CarouselModule,
    CascadeSelectModule,
    ChartModule,
    CheckboxModule,
    ChipsModule,
    ChipModule,
    CodeHighlighterModule,
    ConfirmDialogModule,
    ConfirmPopupModule,
    ColorPickerModule,
    ContextMenuModule,
    DataViewModule,
    DialogModule,
    DividerModule,
    DropdownModule,
    FieldsetModule,
    FileUploadModule,
    GalleriaModule,
    ImageModule,
    InplaceModule,
    InputNumberModule,
    InputMaskModule,
    InputSwitchModule,
    InputTextModule,
    InputTextareaModule,
    KnobModule,
    LightboxModule,
    ListboxModule,
    MegaMenuModule,
    MenuModule,
    MenubarModule,
    MessageModule,
    MessagesModule,
    MultiSelectModule,
    OrderListModule,
    OrganizationChartModule,
    OverlayPanelModule,
    PaginatorModule,
    PanelModule,
    PanelMenuModule,
    PasswordModule,
    PickListModule,
    ProgressBarModule,
    RadioButtonModule,
    RatingModule,
    RippleModule,
    ScrollPanelModule,
    ScrollTopModule,
    SelectButtonModule,
    SidebarModule,
    SkeletonModule,
    SlideMenuModule,
    SliderModule,
    SplitButtonModule,
    SplitterModule,
    WebcamModule,
    GMapModule,
    TranslateModule.forRoot({
      defaultLanguage: 'en',
      loader: {
          provide: TranslateLoader,
          useFactory: (HttpLoaderFactory),
          deps: [HttpClient]
      }
  })
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ApiLoaderInterceptor, multi: true },
    MessageService,
    ConfirmationService,
    MenuService,
    ConfigService,
    FarmerLandDetailService,
    TokenService,
    OnFarmMiService
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent]
})
export class AppModule { }
